import Vue from "vue";
import prototype from "./prototype.js";
import "./jumpPage.js";

Object.keys(prototype).forEach(key => {
    Vue.prototype[`$${key}`] = prototype[key];
});



// WEBPACK FOOTER //
// ./src/global/index.js